import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3TherapyPageState() {
  const therapyPage = useSelector((state: RootState) => state.treatmentPlanV3.therapyPage);
  const therapies = therapyPage?.therapies ?? [];
  const noTherapy = therapyPage?.no_historical_therapy ?? false;
  const hasLoaded = therapyPage !== null;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.therapyPageError != null,
  );
  const therapyPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.therapyPageLoading,
  );
  // Idle (fetch not started) and in-flight both count as loading so the form stays gated.
  const isLoading = therapyPageLoading || (!hasLoaded && !hasLoadError);
  const isSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createTherapyLoading ||
      state.treatmentPlanV3.updateTherapyLoading ||
      state.treatmentPlanV3.deleteTherapyLoading ||
      state.treatmentPlanV3.setNoTherapyLoading,
  );
  // The flag save locks list fields; ordinary row saves must not. The checkbox uses `isSaving`.
  const isBulkSaving = useSelector(
    (state: RootState) => state.treatmentPlanV3.setNoTherapyLoading,
  );

  return { therapies, noTherapy, isLoading, hasLoaded, hasLoadError, isSaving, isBulkSaving };
}
